export default __webpack_public_path__ + "images/781a0a895be5b03c381601df3783b7f0-beer.webp";